import Axios from "./AxiosInstance";

export const getJobs = () => {
  return Axios.get("api/axios/jobs");
};
